import { useCallback } from 'react';
import BigNumber from 'bignumber.js';

import ButtonLink from '#/components/shared/ButtonLink';
import { publishNotification } from '#/features/notifications/topic';

import { logException } from '#/features/logging/logging';

import { useDepositFunds } from './deposit';

interface Props {
  readonly label: string;
  readonly amountRaw: BigNumber;
  readonly asset: string;
}

export default function DepositFundsAction(props: Props) {
  const [depositFunds, { isBusy }] = useDepositFunds();

  const handleClick = useCallback(() => {
    (async () => {
      await depositFunds(props.amountRaw, props.asset);
    })().catch((err) => {
      const message = 'Error depositing funds to Paraclear';
      logException(new Error(message, { cause: err }));
      publishNotification({
        kind: 'deposit-unexpected-error',
        props: {},
      });
    });
  }, [depositFunds, props]);

  return (
    <ButtonLink disabled={isBusy} onClick={handleClick}>
      {props.label}
    </ButtonLink>
  );
}
